export type OrderType = "swap" | "limit" | "dca" | "stop-loss"

export const BUTTON_LABELS = {
  swap: "Swap",
  limit: "Start Limit Order Agent",
  dca: "Start DCA Agent",
  "stop-loss": "Start Stop Loss Agent",
}

export const CONFIRM_DIALOG_TITLES = {
  swap: "Swap",
  limit: "Limit Order",
  dca: "DCA",
  "stop-loss": "Stop Loss",
}
